import { NgModule } from '@angular/core';
import { AlmSearchHighlight } from './alm-search-highlight.pipe';

@NgModule({
  declarations: [ AlmSearchHighlight ],
  exports: [ AlmSearchHighlight ]
})
export class AlmSearchHighlightModule { }
